import CreateAccount from "../components/CreateAccount/CreateAccount";

export default function JoinUs(){
    return(
       <CreateAccount/>
    )
}